export type NomenclatureTab = "upload" | "database";

interface Props {
  activeTab: NomenclatureTab;
  pendingCodeCount: number;
  onSelect: (tab: NomenclatureTab) => void;
}

const TABS: { tab: NomenclatureTab; label: string }[] = [
  { tab: "upload", label: "Upload" },
  { tab: "database", label: "Database" },
];

export function NomenclatureTabs({ activeTab, pendingCodeCount, onSelect }: Props) {
  return (
    <nav
      className="flex gap-1 px-7 bg-rs-black border-b border-rs-jet overflow-x-auto"
      role="tablist"
      aria-label="Nomenclature sections"
    >
      {TABS.map(({ tab, label }) => {
        const isSelected = tab === activeTab;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={isSelected}
            className={`group flex items-center gap-2 whitespace-nowrap bg-transparent border-0 border-b-2 px-3.5 pt-3 pb-2.5 text-sm cursor-pointer ${
              isSelected ? "border-rs-green" : "border-transparent"
            }`}
            onClick={() => onSelect(tab)}
          >
            <b className={`font-semibold group-hover:text-rs-green ${isSelected ? "text-rs-green" : "text-rs-off-white"}`}>
              {label}
            </b>
            {tab === "upload" && pendingCodeCount > 0 && (
              <span className="rounded-full border border-rs-amber/45 bg-rs-amber/9 px-1.75 py-px text-[11.5px] font-medium text-rs-amber">
                {pendingCodeCount} pending
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
